import Markup from '@shared/components/Markup.tsx';

interface ICollapseItemProps {
    id: string;
    parentId: string;
    title: string | null | undefined;
    body: string | null | undefined;
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}
const CollapseItem = ({ id, title, parentId, body, as: Heading = 'h2' }: ICollapseItemProps) => {
    return (
        <div className='card'>
            <div
                className='py-2 px-2'
                id={`collapse-item-${id}-header`}
            >
                <Heading className='mb-0'>
                    <button
                        className='btn btn-link btn-block text-left font-weight-medium'
                        type='button'
                        data-toggle='collapse'
                        data-target={`#collapse-item-${id}`}
                        aria-controls={`collapse-item-${id}-header`}
                    >
                        {title}
                    </button>
                </Heading>
            </div>

            <div
                id={`collapse-item-${id}`}
                className='collapse'
                aria-labelledby={`collapse-item-${id}-header`}
                data-parent={`#${parentId}`}
            >
                <div className='card-body'>
                    <Markup content={body} />
                </div>
            </div>
        </div>
    );
};

export default CollapseItem;
